// Заголовок вкладки и описание страницы после перехода внутри приложения.
//
// Первый ответ сервер собирает сам (server/seo.mjs) — этого хватает роботу и
// разворачивалке ссылок в мессенджере, они смотрят только в исходный HTML.
// Дальше страницы меняются без перезагрузки, и тогда за <title> отвечает уже
// клиент: иначе во вкладке навсегда останется заголовок того адреса, по
// которому человек вошёл.
import { useEffect } from 'react';

/** Словесный знак: он не переводится (см. src/ui/shell/Logo.tsx). */
export const BRAND = 'Plan Your Trip';

export interface DocumentMeta {
  /** Заголовок без знака: '— Plan Your Trip' добавляется сам. */
  title?: string;
  description?: string;
}

function setMetaContent(name: string, content: string): void {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = name;
    document.head.append(tag);
  }
  tag.content = content;
}

export function useDocumentMeta({ title, description }: DocumentMeta): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.title = title ? `${title} — ${BRAND}` : BRAND;
    if (description) setMetaContent('description', description);
  }, [title, description]);
}
